import { render, staticRenderFns } from "./ImageUpload.vue?vue&type=template&id=62b901e0&scoped=true&"
import script from "./ImageUpload.vue?vue&type=script&lang=js&"
export * from "./ImageUpload.vue?vue&type=script&lang=js&"
import style0 from "./ImageUpload.vue?vue&type=style&index=0&id=62b901e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b901e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62b901e0')) {
      api.createRecord('62b901e0', component.options)
    } else {
      api.reload('62b901e0', component.options)
    }
    module.hot.accept("./ImageUpload.vue?vue&type=template&id=62b901e0&scoped=true&", function () {
      api.rerender('62b901e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/manageGoodsGroup/publishGoods/components/ImageUpload.vue"
export default component.exports